<template>
  <div>
    <div v-if="!isFooterOnly">
      <div class="field">
        <label class="label">Serial Number *</label>
        <div class="control">
          <input
            class="input"
            type="text"
            v-model="form.serial_number"
            placeholder="e.g. SN-001234"
          />
        </div>
      </div>
    </div>

    <div v-else class="buttons">
      <button class="button" @click="closeTopModal">Cancel</button>
      <button
        :class="['button', 'is-primary', isSaving ? 'is-loading' : '']"
        @click="triggerSubmit"
      >
        Add Inventory
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { httpInstance as http } from "@/plugins/http";
import toast from "@/utils/toast";

export default {
  name: "ModalAddProCameraInventory",
  props: {
    modalData: { type: Object, default: () => ({}) },
    modalIndex: { type: Number, required: true },
    isFooterOnly: { type: Boolean, default: false },
  },
  data() {
    return {
      form: { serial_number: "" },
    };
  },
  computed: {
    ...mapState(["isSaving"]),
  },
  methods: {
    ...mapActions(["closeTopModal", "fetchList"]),
    triggerSubmit() {
      this.$root.$emit("add-pro-camera-inventory-submit");
    },
    async handleSubmit() {
      if (!this.form.serial_number.trim()) {
        toast.error("Serial number is required");
        return;
      }
      try {
        const res = await http.post("pro-camera/inventories", {
          serial_number: this.form.serial_number.trim(),
        });
        if (res?.status > 299) {
          toast.error(res?.data?.message || "Failed to create inventory");
          return;
        }
        toast.success("Inventory created");
        this.closeTopModal();
        this.fetchList();
      } catch {
        toast.error("Failed to create inventory");
      }
    },
  },
  mounted() {
    if (!this.isFooterOnly) {
      this.$root.$on("add-pro-camera-inventory-submit", this.handleSubmit);
    }
  },
  beforeDestroy() {
    if (!this.isFooterOnly) {
      this.$root.$off("add-pro-camera-inventory-submit", this.handleSubmit);
    }
  },
};
</script>

<style scoped>
.buttons { justify-content: flex-end; }
</style>
